module.exports = __webpack_public_path__ + "images/emoji/finnadie.a06963383cf98607925b.png";